import React, { useRef, useEffect, useState } from 'react';
import './PreviewModule.css';
import Notification from '../../Notification/Notification'; // Import the Notification component

const PreviewModule = ({ template, onClose }) => {
  const iframeRef = useRef(null);
  const [viewMode, setViewMode] = useState('desktop'); // Default to desktop view
  const [email, setEmail] = useState(''); // State for email input
  const [notification, setNotification] = useState({ message: '', type: '' }); // State for notification
  const [loading, setLoading] = useState(false); // Add loading state

  useEffect(() => {
    if (iframeRef.current && template.html) {
      const doc = iframeRef.current.contentDocument || iframeRef.current.contentWindow.document;
      doc.open();
      doc.write(template.html);
      doc.close();
    }
  }, [template.html]);

  const handleSendTest = async () => {
    if (!email) {
      setNotification({ message: 'Please enter an email address.', type: 'error' });
      return;
    }

    setLoading(true); // Disable the button and show the spinner
    setNotification({ message: '', type: '' }); // Clear previous notifications

    // Determine subject based on template type
    const subjectPrefix = template.type === 'amp' ? 'Interactive' : 'Normal';
    const subject = `${subjectPrefix} Template: ${template.title}`;

    try {
      const response = await fetch('https://sriharim.in/php/send-test-email1.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          htmlContent: template.html,
          subject: subject // Include subject in the payload
        }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! Status: ${response.status}, Response: ${errorText}`);
      }

      const result = await response.json();

      if (result.status === 'success') {
        setNotification({ message: result.message, type: 'success' });
        setEmail(''); // Clear input after sending
      } else {
        setNotification({ message: result.message || 'Failed to send test email.', type: 'error' });
      }
    } catch (error) {
      console.error('Error sending test email:', error);
      setNotification({ message: `An error occurred: ${error.message}`, type: 'error' });
    } finally {
      setLoading(false); // Re-enable the button
    }
  };

  const handleViewModeChange = (mode) => {
    console.log(`Switching to ${mode} view`); // Debug log
    setViewMode(mode);
  };

  const closeNotification = () => {
    setNotification({ message: '', type: '' });
  };

  return (
    <div className="previewmodule-overlay" onClick={onClose}>
      <Notification
        message={notification.message}
        type={notification.type}
        onClose={closeNotification}
      />
      <div className="previewmodule-content" onClick={(e) => e.stopPropagation()}>
        <button className="previewmodule-close" onClick={onClose}>
          ×
        </button>
        <h2 className="previewmodule-title">{template.title}</h2>
        <div className="previewmodule-toolbar">
          {/* Conditionally render the email section based on template type */}
          {template.type !== 'amp' && (
            <div className="previewmodule-email-section">
              <input
                type="email"
                className="previewmodule-email-input"
                placeholder="Enter email to send test"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button
                className="previewmodule-send-test"
                onClick={handleSendTest}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner"></span>
                  </>
                ) : (
                  'Send Test'
                )}
              </button>
            </div>
          )}
          <div className="previewmodule-view-toggle">
            <span
              className={`previewmodule-icon ${viewMode === 'desktop' ? 'active' : ''}`}
              onClick={() => handleViewModeChange('desktop')}
              title="Desktop View"
            >
              🖥️
            </span>
            <span
              className={`previewmodule-icon ${viewMode === 'mobile' ? 'active' : ''}`}
              onClick={() => handleViewModeChange('mobile')}
              title="Mobile View"
            >
              📱
            </span>
          </div>
        </div>
        <div className="previewmodule-preview">
          <iframe
            ref={iframeRef}
            className={`previewmodule-iframe ${viewMode}`}
            title={`${template.title} Preview`}
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default PreviewModule;